import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BlockStack, Navigation } from "@shopify/polaris";
import {
  DeleteMajor,
  DynamicSourceMajor,
  LogOutMinor,
  OrganizationMajor,
  ProfileMajor,
} from "@shopify/polaris-icons";
import { removeLocalStorageItem } from "@/Utils/Index";

function AdminNavigationMenu() {
  const navigate = useNavigate();

  const location = useLocation();
  const [selected, setSelected] = useState(location.pathname);

  const handleLogout = () => {
    removeLocalStorageItem("authorizationAdminPanel");
    navigate("/admin/login");
  };
  const menu = [
    {
      label: "User",
      icon: ProfileMajor,
      destination: "/admin/user",
    },
    {
      label: "Organization",
      icon: OrganizationMajor,
      destination: "/admin/organization",
    },
    {
      label: "GetData",
      icon: DynamicSourceMajor,
      destination: "/admin/getdata",
    },
  ];

  const handleClick = useCallback((item) => {
    navigate(item.destination);
    setSelected(item.destination);
  }, []);

  return (
    <Navigation location={location.pathname}>
      <BlockStack>
        <Navigation.Section
          items={menu.map((item) => ({
            ...item,
            onClick: () => handleClick(item),
            selected: selected === item.destination,
          }))}
        />
        <Navigation.Section
          title="Others"
          items={[
            {
              label: "Logout",
              icon: LogOutMinor,
              onClick: handleLogout,
            },
          ]}
          rollup={{
            after: 0,
            view: "view",
            hide: "hide",
            activePath: "#",
          }}
        />
      </BlockStack>
    </Navigation>
  );
}

export default AdminNavigationMenu;
